export function parseProfileDeleteError(payload) {
  const generalError = payload?.general_error ?? payload;
  if (generalError?.error_code === 'profile_in_use') {
    return {
      errorCode: 'profile_in_use',
      message: generalError.message || 'Profile is assigned to users and cannot be deleted.',
      assignedUsersCount: generalError.assigned_users_count ?? 0,
      assignedUsers: generalError.assigned_users || [],
    };
  }

  return null;
}
